/* Notices ajoutees : installation BFT (chargees apres documentation-app.js, avant init) */
DOCS.push(
    { id: 'bft-kustos-bt-b', brand: 'bft', cat: 'moteur_batt', family: 'KUSTOS',
      title: 'BFT KUSTOS BT B25 / B40', subtitle: '24V · Vérin à vis carénée · Max 700kg · 4m',
      tags: [['24V','green'],['700 kg','gray'],['Vis carénée','blue']],
      ref: 'D814422',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_installation_kustos_bt_b_bft.pdf',
      product: 'https://portail-systeme.fr/products/moteur-bft-kustos-bt-b25-portail-battant-p935127-00002' },

    { id: 'bft-phobos-bt-b', brand: 'bft', cat: 'moteur_batt', family: 'PHOBOS',
      title: 'BFT PHOBOS BT B40 / VELOCE B35', subtitle: '24V · Vérin compact · Max 700kg · 4m',
      tags: [['24V','green'],['700 kg','gray'],['Compact','blue']],
      ref: 'D814418',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_installation_phobos_bt_b_veloce_bft.pdf',
      product: 'https://portail-systeme.fr/products/moteur-bft-phobos-bt-b40-portail-battant-p935130-00002' },

    { id: 'bft-phobos-ac-b', brand: 'bft', cat: 'moteur_batt', family: 'PHOBOS',
      title: 'BFT PHOBOS AC B25 / B50', subtitle: '230V · Vérin irréversible · Max 500kg · 5m',
      tags: [['230V','orange'],['500 kg','gray'],['Irréversible','blue']],
      ref: 'D814395',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_installation_phobos_ac_b_bft.pdf',
      product: 'https://portail-systeme.fr/products/moteur-bft-phobos-ac-b50-portail-battant-p935133-00002' },

    { id: 'bft-e5-bt', brand: 'bft', cat: 'moteur_batt', family: 'E5',
      title: 'BFT E5 BT A18 / A12', subtitle: '24V · Ultra-compact · Pilier 80mm · Encodeur absolu',
      tags: [['24V','green'],['Pilier 80mm','blue'],['Encodeur','purple']],
      ref: 'D814068',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_installation_e5_bt_a18_a12_bft.pdf',
      product: 'https://portail-systeme.fr/products/moteur-bft-e5-bt-a18-portail-battant-p930027-00001' },

    { id: 'bft-igea-bt', brand: 'bft', cat: 'moteur_batt', family: 'IGEA',
      title: 'BFT IGEA BT', subtitle: '24V · Bras articulé · Max 250kg · 2,5m',
      tags: [['24V','green'],['250 kg','gray'],['Bras articulé','blue']],
      ref: 'D811369',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_installation_igea_bt_bft.pdf',
      product: 'https://portail-systeme.fr/products/moteur-bft-igea-bt-24v-bras-articule-p935070-00002' },

    { id: 'bft-ares-veloce-smart', brand: 'bft', cat: 'moteur_coul', family: 'ARES',
      title: 'BFT ARES VELOCE SMART BT A500 / A1000', subtitle: '24V · Rapide · Max 500-1000kg',
      tags: [['24V','green'],['1000 kg','gray'],['Rapide','orange']],
      ref: 'D814275',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_installation_ares_veloce_smart_bt_bft.pdf',
      product: 'https://portail-systeme.fr/products/moteur-bft-ares-veloce-smart-bt-b500-rapide-portail-coulissant-p926205-00002' },

    { id: 'bft-sp3500', brand: 'bft', cat: 'moteur_coul', family: 'SP3500',
      title: 'BFT SP3500 (230V / 400V)', subtitle: 'Triphasé · Max 3500kg · Industriel',
      tags: [['Triphasé','purple'],['3500 kg','gray'],['Industriel','purple']],
      ref: 'D812213',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_installation_sp3500_bft.pdf',
      product: 'https://portail-systeme.fr/products/moteur-bft-sp3500-230v-triphase-portail-coulissant-industriel-p925207-00002' },

    { id: 'bft-oberon', brand: 'bft', cat: 'moteur_coul', family: 'OBERON',
      title: 'BFT OBERON TRI A2000 INV', subtitle: 'Triphasé · Variateur · Max 2000kg · Industriel',
      tags: [['Triphasé','purple'],['Variateur','blue'],['2000 kg','gray']],
      ref: 'D811957',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_installation_oberon_bft.pdf',
      product: 'https://portail-systeme.fr/products/moteur-bft-oberon-ce-variateur-portail-coulissant-industriel-p925218-00002' },

    { id: 'bft-compacta', brand: 'bft', cat: 'photocellule', family: 'COMPACTA',
      title: 'BFT COMPACTA A20-180', subtitle: 'Photocellules orientables 180° · Portée 20m',
      tags: [['20 m','gray'],['Orientable 180°','blue'],['12-33V','green']],
      ref: 'D814003',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_installation_compacta_a20_180_bft.pdf',
      product: 'https://portail-systeme.fr/products/photocellules-bft-compacta-a20-180-portee-20m-portail-p111782' },

    { id: 'bft-virgo-linx', brand: 'bft', cat: 'centrale', family: 'LINX',
      title: 'BFT VIRGO / Centrale LINX', subtitle: 'Centrale 24V · Moteurs Virgo · Kit batteries',
      tags: [['24V','green'],['Virgo','blue'],['Batteries','purple']],
      ref: 'D811415',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_installation_virgo_linx_bft.pdf',
      product: 'https://portail-systeme.fr/products/centrale-commande-bft-linx-moteur-virgo-portail-battant-i104317' }
);

/* ============================================================
   MARQUE MHOUSE (by Nice) — ajoutee le 16/09/2026
   documentation-app.js n'est pas modifie : la marque est
   enregistree ici (BRANDS, BRAND_IDS, ALL_ACTIVE, logos, noms)
   et render() est redefini pour inclure 'mhouse' dans l'ordre
   des sections. Couleurs : voir .mhouse dans documentation-content.liquid
   ============================================================ */
BRANDS.push({ id: 'mhouse', label: 'Mhouse' });
BRAND_IDS.push('mhouse');
ACTIVE_CLASSES.push('active-mhouse');
ALL_ACTIVE.push('active-mhouse');
BRAND_NAMES.mhouse = 'Mhouse';
BRAND_LOGOS.mhouse = 'https://portail-systeme.fr/cdn/shop/files/Logo_mhouse.png';
BRAND_ALTS.mhouse  = 'Logo Mhouse by Nice';

/* La telecommande GTX4 etait rangee sous Nice : on la rebascule sous Mhouse */
(function () {
    const gtx4 = DOCS.find(d => d.id === 'nice-mhouse-gtx4');
    if (gtx4) {
        gtx4.id = 'mhouse-gtx4';
        gtx4.brand = 'mhouse';
        gtx4.family = 'GTX';
        gtx4.tags = [['Rolling code','green'],['4 canaux','blue'],['433.92 MHz','gray']];
    }
})();

DOCS.push(
    { id: 'mhouse-wg2w', brand: 'mhouse', cat: 'moteur_batt', family: 'WG2',
      title: 'Mhouse WG2W (MhouseKit)', subtitle: '24V · Bras articulé · 2 vantaux · Centrale CL2',
      tags: [['24V','green'],['Bras articulé','blue'],['Centrale CL2','purple']],
      ref: 'MhouseKit WG2W',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_wg2w_mhouse.pdf',
      product: 'https://portail-systeme.fr/products/carte-electronique-mhouse-cl2kit-02-portail-battant-wg2-ws2-wu2-ww2' },

    { id: 'mhouse-wg2s', brand: 'mhouse', cat: 'moteur_batt', family: 'WG2',
      title: 'Mhouse WG2S (MhouseKit)', subtitle: '24V · Bras articulé · 2 vantaux · Centrale CL2S',
      tags: [['24V','green'],['Bras articulé','blue'],['Centrale CL2S','purple']],
      ref: 'MhouseKit WG2S',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_wg2s_mhouse.pdf',
      product: 'https://portail-systeme.fr/products/carte-electronique-mhouse-cl7sk-portail-battant' },

    { id: 'mhouse-wg20s', brand: 'mhouse', cat: 'moteur_batt', family: 'WG20',
      title: 'Mhouse WG20S (MhouseKit)', subtitle: '24V · Bras articulé · 2 vantaux',
      tags: [['24V','green'],['Bras articulé','blue'],['2 vantaux','gray']],
      ref: 'MhouseKit WG20S',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_wg20s_mhouse.pdf',
      product: null },

    { id: 'mhouse-wg10s', brand: 'mhouse', cat: 'moteur_batt', family: 'WG10',
      title: 'Mhouse WG10S (MhouseKit)', subtitle: '24V · Bras articulé · 1 vantail',
      tags: [['24V','green'],['Bras articulé','blue'],['1 vantail','gray']],
      ref: 'MhouseKit WG10S',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_wg10s_mhouse.pdf',
      product: null },

    { id: 'mhouse-ws200w', brand: 'mhouse', cat: 'moteur_batt', family: 'WS200',
      title: 'Mhouse WS200W (MhouseKit)', subtitle: '24V · Vérin · 2 vantaux',
      tags: [['24V','green'],['Vérin','blue'],['2 vantaux','gray']],
      ref: 'MhouseKit WS200W',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ws200w_mhouse.pdf',
      product: null },

    { id: 'mhouse-ws200s', brand: 'mhouse', cat: 'moteur_batt', family: 'WS200',
      title: 'Mhouse WS200S (MhouseKit)', subtitle: '24V · Vérin · 2 vantaux · Centrale CL7SKA',
      tags: [['24V','green'],['Vérin','blue'],['Centrale CL7SKA','purple']],
      ref: 'MhouseKit WS200S',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ws200s_mhouse.pdf',
      product: 'https://portail-systeme.fr/products/carte-electronique-mhouse-cl7ska-portail-battant-ws200s' },

    { id: 'mhouse-ws2000s', brand: 'mhouse', cat: 'moteur_batt', family: 'WS2000',
      title: 'Mhouse WS2000S (MhouseKit)', subtitle: '24V · Vérin · 2 vantaux · Opérateurs WS1000SC / WS1000SK',
      tags: [['24V','green'],['Vérin','blue'],['2 vantaux','gray']],
      ref: 'MhouseKit WS2000S',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ws2000s_mhouse.pdf',
      product: null },

    { id: 'mhouse-wu200s', brand: 'mhouse', cat: 'moteur_batt', family: 'WU200',
      title: 'Mhouse WU200S (MhouseKit)', subtitle: '24V · Vérin · 2 vantaux · Armoire CL2S',
      tags: [['24V','green'],['Vérin','blue'],['Armoire CL2S','purple']],
      ref: 'MhouseKit WU200S',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_wu200s_mhouse.pdf',
      product: 'https://portail-systeme.fr/products/armoire-commande-mhouse-cl2s-portail-battant-wg2s-wu2s' },

    { id: 'mhouse-wt1s', brand: 'mhouse', cat: 'moteur_batt', family: 'WT',
      title: 'Mhouse WT1S (MhouseKit)', subtitle: '24V · Vis sans fin · 1 vantail',
      tags: [['24V','green'],['Vis sans fin','blue'],['1 vantail','gray']],
      ref: 'MhouseKit WT1S',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_wt1s_mhouse.pdf',
      product: null },

    { id: 'mhouse-wt2s', brand: 'mhouse', cat: 'moteur_batt', family: 'WT',
      title: 'Mhouse WT2S (MhouseKit)', subtitle: '24V · Vis sans fin · 2 vantaux',
      tags: [['24V','green'],['Vis sans fin','blue'],['2 vantaux','gray']],
      ref: 'MhouseKit WT2S',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_wt2s_mhouse.pdf',
      product: null },

    { id: 'mhouse-sl1w', brand: 'mhouse', cat: 'moteur_coul', family: 'SL1',
      title: 'Mhouse SL1W (MhouseKit)', subtitle: '24V · Coulissant · Centrale CL1',
      tags: [['24V','green'],['Coulissant','blue'],['Centrale CL1','purple']],
      ref: 'MhouseKit SL1W',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sl1w_mhouse.pdf',
      product: null },

    { id: 'mhouse-sl1s', brand: 'mhouse', cat: 'moteur_coul', family: 'SL1',
      title: 'Mhouse SL1S (MhouseKit)', subtitle: '24V · Coulissant · Centrale CL1SK',
      tags: [['24V','green'],['Coulissant','blue'],['Centrale CL1SK','purple']],
      ref: 'MhouseKit SL1S',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sl1s_mhouse.pdf',
      product: 'https://portail-systeme.fr/products/carte-electronique-mhouse-cl1sk-portail-coulissant-sl1s-sl10s' },

    { id: 'mhouse-sl10s', brand: 'mhouse', cat: 'moteur_coul', family: 'SL10',
      title: 'Mhouse SL10S (MhouseKit)', subtitle: '24V · Coulissant · Centrale CL1SK',
      tags: [['24V','green'],['Coulissant','blue'],['Centrale CL1SK','purple']],
      ref: 'MhouseKit SL10S',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sl10s_mhouse.pdf',
      product: 'https://portail-systeme.fr/products/carte-electronique-mhouse-cl1sk-portail-coulissant-sl1s-sl10s' },

    { id: 'mhouse-gd0c', brand: 'mhouse', cat: 'moteur_garage', family: 'GD0',
      title: 'Mhouse GD0C (MhouseKit)', subtitle: '24V · Sectionnelle/Basculante · Chaîne',
      tags: [['24V','green'],['Sectionnelle','blue'],['Chaîne','gray']],
      ref: 'MhouseKit GD0C',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_gd0c_mhouse.pdf',
      product: null },

    { id: 'mhouse-gd1n', brand: 'mhouse', cat: 'moteur_garage', family: 'GD1',
      title: 'Mhouse GD1N (MhouseKit)', subtitle: '24V · Sectionnelle/Basculante',
      tags: [['24V','green'],['Sectionnelle','blue'],['Basculante','gray']],
      ref: 'MhouseKit GD1N',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_gd1n_gd10n_mhouse.pdf',
      product: null },

    { id: 'mhouse-gd10n', brand: 'mhouse', cat: 'moteur_garage', family: 'GD10',
      title: 'Mhouse GD10N (MhouseKit)', subtitle: '24V · Sectionnelle/Basculante',
      tags: [['24V','green'],['Sectionnelle','blue'],['Basculante','gray']],
      ref: 'MhouseKit GD10N',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_gd1n_gd10n_mhouse.pdf',
      product: null },

    { id: 'mhouse-pf', brand: 'mhouse', cat: 'centrale', family: 'PF',
      title: 'Mhouse PF Power&Free (MhouseKit)', subtitle: 'Alimentation solaire · Panneau + batterie · 24V',
      tags: [['Solaire','orange'],['24V','green'],['Power&Free','purple']],
      ref: 'MhouseKit PF',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_pf_mhouse.pdf',
      product: null }
);

/* render() redefini a l'identique, avec 'mhouse' dans brandOrder */
render = function () {
    const filtered = getFiltered();
    const isFiltered = state.cat !== 'all' || state.brand !== 'all' || state.query;
    const $grid = document.getElementById('docsGrid');
    const $empty = document.getElementById('emptyState');
    const $count = document.getElementById('resultCount');
    const $clearBtn = document.getElementById('clearFilters');

    $clearBtn.classList.toggle('hidden', !isFiltered);

    document.querySelectorAll('#catPills .pill').forEach(btn => {
        btn.querySelector('.count').textContent = countDocs(state.brand, btn.dataset.cat, state.query);
    });
    document.querySelectorAll('#brandPills .pill').forEach(btn => {
        btn.querySelector('.count').textContent = countDocs(btn.dataset.brand, state.cat, state.query);
    });

    $count.textContent = isFiltered
        ? `${filtered.length} résultat${filtered.length !== 1 ? 's' : ''} sur ${DOCS.length}`
        : `${DOCS.length} notices disponibles`;

    if (filtered.length === 0) {
        $grid.innerHTML = '';
        $empty.classList.remove('hidden');
        return;
    }
    $empty.classList.add('hidden');

    const showBrandHeadings = !state.query;
    let html = '';
    let cardIndex = 0;

    if (showBrandHeadings) {
        const brandOrder = ['nice', 'mhouse', 'came', 'faac', 'somfy', 'bft', 'cardin'];
        brandOrder.forEach(brandId => {
            const brandDocs = filtered.filter(d => d.brand === brandId);
            if (brandDocs.length === 0) return;
            const catSuffix = state.cat !== 'all'
                ? ` — <span class="material-icons-round section-cat-icon">${CAT_ICONS[state.cat]}</span> ${CATEGORIES.find(c => c.id === state.cat)?.label || ''}`
                : '';
            html += `<h2 class="section-heading" id="section-${brandId}">
                <img src="${BRAND_LOGOS[brandId]}" alt="${BRAND_ALTS[brandId]}" class="section-brand-logo">
                Notices de programmation ${BRAND_NAMES[brandId]}${catSuffix}
                <span class="section-count">${brandDocs.length}</span>
            </h2>`;
            html += brandDocs.map(d => renderCard(d, cardIndex++)).join('');
        });
    } else {
        html = filtered.map((d, i) => renderCard(d, i)).join('');
    }

    $grid.innerHTML = html;
};
